import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  makeStyles,
  Typography,
} from 'transfix-ui/core'
import { v4 as uuidv4 } from 'uuid'
import { PlusIcon } from 'transfix-icons'

interface IParserValidationErrorsModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onCancel: () => void
  schemaErrors?: [string[]]
}

const useParserValidationErrorsModalStyles = makeStyles({
  accordianDetails: {
    display: 'block',
  },
})

export const ParserValidationErrorsModal = ({
  onCancel,
  schemaErrors,
  ...props
}: IParserValidationErrorsModalProps) => {
  const schemaErrorsData = schemaErrors?.map(errors => ({
    id: uuidv4(),
    errors,
  }))

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Close',
      action: () => {
        onCancel()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  const classes = useParserValidationErrorsModalStyles()

  return (
    <ModalBase
      dataTest='ParserValidationStautsModal'
      modalType={MODAL_TYPES.confirmation}
      size={3}
      open
      actions={actions}
      title='Schema Errors'
      closeOnBackdropClick
      {...props}>
      <Box>
        <Box mb={2}>
          <Typography variant='body1'>Your schema has validation errors</Typography>
        </Box>
        <Box>
          {schemaErrorsData?.map(({ errors, id }, index) => {
            return (
              <Box mb={2} key={id}>
                <Accordion>
                  <AccordionSummary expandIcon={<PlusIcon />} id='panel1a-header'>
                    <Typography>{`Shipment ${index + 1} errors`}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordianDetails}>
                    {errors.map(error => {
                      return <Typography key={error}>{error}</Typography>
                    })}
                  </AccordionDetails>
                </Accordion>
              </Box>
            )
          })}
        </Box>
      </Box>
    </ModalBase>
  )
}
